import { render, staticRenderFns } from "./Men.vue?vue&type=template&id=d27c84a2&"
import script from "./Men.vue?vue&type=script&lang=js&"
export * from "./Men.vue?vue&type=script&lang=js&"
import style0 from "./Men.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports